import { trigger, state, style, transition, animate, group, query, stagger, keyframes } from '@angular/animations';

export const DialogAnimation = [
    trigger('dialog', [
        transition('void => *', [
            style({ transform: 'translate(-50%, -65%) scale3d(.8, .8, 5)', opacity: .2 }),
            animate(200),
        ]),
        transition('* => void', [
            animate(200, style({ opacity: 0 }))
        ])
    ])
];
